import { Controller } from "@hotwired/stimulus"

// Manages the dynamic list of selected Google Docs. Each row carries its own google-picker
// controller plus hidden documents[][id] / documents[][name] inputs. Adding clones the
// <template>; removing deletes the row from the DOM so it is simply not submitted.
export default class extends Controller {
  static targets = ["template", "list"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML
    this.listTarget.insertAdjacentHTML('beforeend', content)
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-docs-list-row]").remove()
  }
}
